export default __webpack_public_path__ + "static/media/icon.63cb91a2.svg";